import { useSelector } from "react-redux";
import styled, { css } from "styled-components";
import { ButtonsVariant, Theme } from "../../../constants";
import { device } from "../../../devices";
import { UserContextSelectors } from "../../../redux/selectors";
import { PageContextUtils } from "../../../utils";

const CTAButtonWrapper = styled.button`
  ${() => {
    const isMobile = useSelector(UserContextSelectors.isMobile);
    const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
    const { currentName = Theme.Default } = PageContextUtils.getThemeData();

    if (isMobile && !isAuthenticated) {
      return css`
        width: ${props => props.width || "10rem"};
        height: ${props => props.height || "3rem"};
        font-weight: ${props => props.theme.typography.fontWeightMobile};
        font-size: ${props => props.theme.typography.fontSizeMobile};

        ${props => {
          if (props.variant === ButtonsVariant.Outlined) {
            return css`
              background-color: transparent;
              color: ${props => props.theme.colors.textColorBtnOutlined};
              border-color: ${props => props.theme.borders.borderColorMobile};
            `;
          } else if (props.variant === ButtonsVariant.Contained) {
            return css`
              border-color: ${props => props.color};
              background-color: ${props => props.color};
              color: ${props => props.theme.colors.textColorBtnContainedMobile};
              ${() => {
                if (currentName === Theme.MrGreen) {
                  return css`
                    border: solid 2px transparent;
                    background: rgb(241, 193, 65);
                    background: -moz-linear-gradient(
                      90deg,
                      rgba(241, 193, 65, 1) 0%,
                      rgba(249, 241, 154, 1) 50%,
                      rgba(241, 193, 65, 1) 100%
                    );
                    background: -webkit-linear-gradient(
                      90deg,
                      rgba(241, 193, 65, 1) 0%,
                      rgba(249, 241, 154, 1) 50%,
                      rgba(241, 193, 65, 1) 100%
                    );
                    background: linear-gradient(
                      90deg,
                      rgba(241, 193, 65, 1) 0%,
                      rgba(249, 241, 154, 1) 50%,
                      rgba(241, 193, 65, 1) 100%
                    );
                    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f1c141",endColorstr="#f1c141",GradientType=1);
                    color: var(--primary-color-dark);
                  `;
                }
              }}
            `;
          }
        }};
      `;
    } else {
      return css`
        width: ${props => props.width || "15rem"};
        height: ${props => props.height || "4rem"};

        font-weight: ${props => props.theme.typography.fontWeight};
        font-size: ${props => props.theme.typography.fontSize};
        border-color: ${props => props.color};

        ${props => {
          if (props.variant === ButtonsVariant.Outlined) {
            return css`
              background-color: transparent;
              color: ${props => props.theme.colors.textColorBtnOutlined};
              border-color: ${props => props.theme.borders.borderColor};

              &:hover {
                color: ${props =>
                  isAuthenticated
                    ? props.hoverColor
                    : props.theme.colors.textColorBtnOutlinedHover};
                border-color: ${props => props.hoverColor};
                background-color: ${props =>
                  props.theme.backgrounds.hoverColorOutlined};
              }
            `;
          } else if (props.variant === ButtonsVariant.Contained) {
            return css`
              background-color: ${props => props.color};
              color: ${props => props.theme.colors.textColorBtnContained};
              &:hover {
                color: ${props => props.color};
                background-color: ${props =>
                  props.theme.backgrounds.hoverColorContained};
              }
              ${() => {
                if (
                  (!isAuthenticated || props.isPremiumButton) &&
                  currentName === Theme.MrGreen
                ) {
                  return css`
                    border: solid 2px transparent;
                    background: rgb(241, 193, 65);
                    background: -moz-linear-gradient(
                      90deg,
                      rgba(241, 193, 65, 1) 0%,
                      rgba(249, 241, 154, 1) 50%,
                      rgba(241, 193, 65, 1) 100%
                    );
                    background: -webkit-linear-gradient(
                      90deg,
                      rgba(241, 193, 65, 1) 0%,
                      rgba(249, 241, 154, 1) 50%,
                      rgba(241, 193, 65, 1) 100%
                    );
                    background: linear-gradient(
                      90deg,
                      rgba(241, 193, 65, 1) 0%,
                      rgba(249, 241, 154, 1) 50%,
                      rgba(241, 193, 65, 1) 100%
                    );
                    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f1c141",endColorstr="#f1c141",GradientType=1);
                    color: var(--primary-color-dark);

                    &:hover {
                      background: var(--primary-color-dark);
                      border: solid 2px var(--premium-gold);
                      color: var(--premium-gold);
                    }
                  `;
                }
              }}
            `;
          }
        }};
      `;
    }
  }}

  text-transform: uppercase;
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamilyBold};
  border-radius: 2rem;
  border-style: solid;

  @media ${device.tableScreenPortrait} {
    width: 12.5rem;
  }
  @media ${device.tabletScreenLandscape} {
    width: 12.5rem;
  }
  @media ${device.desktopScreen} {
    width: 15rem;
    line-height: normal;
  }
`;

export { CTAButtonWrapper };
